module.exports = __webpack_public_path__ + "static/myrkul_MTG_CLB-2834a4c1e117a0dfdfe78907d2014239.jpeg";